<template>
    <div class="card-body">
        <form @submit.prevent="$emit('getReport')">
            <div class="row">
                <div class="col-12">
                    <b-alert show variant="yellow-light">
                        <span class="text-red">สำหรับลูกค้านิติบุคคล กรณีขอหัก ณ ที่จ่าย จะต้องดำเนินการส่งใบหัก ณ ที่จ่ายมาที่บริษัท (ที่อยู่ตามข้อมูลในใบเสร็จ) ภายในวันที่ 10 ของเดือนถัดไป และฝ่ายบัญชีจะโอนเงินคืนภายในสิ้นเดือนนั้น</span>
                    </b-alert>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-6 col-xl-3">
                    <b-form-group :label="'วันที่ออกใบเสร็จ (วันเริ่มต้น - วันสุดท้าย)'" class="mb-0">
                        <date-range-picker
                            class="w-100"
                            @start-selection="logEvent('startSelection', $event)"
                            @finish-selection="logEvent('finishSelection', $event)"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :open="'center'"
                            :singleDatePicker="false"
                            :appendToBody="true"
                            :ranges="false"
                            :closeOnEsc="false"
                            :autoApply="true"
                            :locale-data="{ format: 'dd/mm/yyyy' }"
                            v-model="search.date"
                        >
                        </date-range-picker>
                    </b-form-group>
                </div>
                <template v-if="!this.$USER_LOGIN.get().isAdmin">
                    <div class="col-12 col-md-12 col-lg-4 col-xl-4 pt-2" v-if="this.$USER_LOGIN.get().isShippop">
                        <label>รายชื่อ Super Admin</label>
                        <v-select
                            :options="listAgent"
                            label="name"
                            placeholder="รายชื่อ Super Admin"
                            v-model="search.saCode"
                            :reduce="selectAgent => selectAgent.dealer_id"
                        >
                            <template v-slot:option="option">
                                <span>{{ option.dealer_id }} ( {{option.name}} )</span>
                            </template>
                        </v-select>
                    </div>
                    <div :class="['col-12 col-md-12 pt-2', (this.$USER_LOGIN.get().isShippop) ? 'col-lg-4 col-xl-4' : 'col-lg-5 col-xl-5' ]">
                        <label>รายชื่อร้านค้า</label>
                        <v-select
                            :options="listShop"
                            label="name"
                            placeholder="รายชื่อร้านค้า"
                            v-model="search.shopCode"
                            :reduce="selectShop => selectShop.shop_code"
                        >
                            <template v-slot:option="option">
                                <span>{{ option.shop_code }} ( {{option.name}} )</span>
                            </template>
                        </v-select>
                    </div>
                </template>
                <template>
                    <div class="col-12 col-md-12 col-lg-4 col-xl-3">
                        <b-form-group :label="'ค้นหาด้วยเลขที่ใบเสร็จ'" class="mb-0">
                            <b-form-input
                                type="text"
                                placeholder="ค้นหาด้วยเลขที่ใบเสร็จ"
                                v-model="search.receiptNo"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </template>
                <div class="col-12 col-md-12 col-lg-2 col-xl-1 d-flex align-items-end pt-4">
                    <b-button type="submit" variant="info" block>
                        <i class="fas fa-circle-notch fa-spin" v-if="search.isLoading"></i>
                        <i class="fa fa-search" v-else></i>
                    </b-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import moment from 'moment'
import { dateLimitRanges } from '@/plugins/datePicker'
import { getListShop } from '@/axios/shop'
import { getListAgent } from '@/axios/agent'
import { showErrorModal } from '@/components/modalNotification.js'

export default {
    props: {
        search: Object
    },
    data() {
        return {
            minDate: null,
            maxDate: moment().format('YYYY-MM-DD'),
            listShop: [ {shop_code:null , name:"ดูทั้งหมด"} ],
            listAgent: [ {dealer_id: null , name: 'ดูทั้งหมด'} ]
        }
    },
    mounted() {
        this.defaultLoad()
    },
    methods: {
        defaultLoad() {
            if( !this.$USER_LOGIN.get().isAdmin ){
                getListShop(true).then( shop => {
                    this.listShop = [ ...this.listShop , ...shop];
                }).catch( error => {
                    showErrorModal( error )
                })

                if( !this.$USER_LOGIN.get().isSuperadmin ){
                    getListAgent().then( agent => {
                        this.listAgent = [ ...this.listAgent , ...agent];
                    })
                }

            }
        },
        logEvent(event, date) {
            const { minDate, maxDate } = dateLimitRanges(event, date)
            this.minDate = minDate
            this.maxDate = maxDate
        }
    }
}
</script>
